var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useAnalytics, useShowFlag, useQuery, useMutation, FlexDiv, Link, isSufficientPermission, Tags } from "@atlassiansox/microscopekit";
import Tooltip from "@atlaskit/tooltip";
import Popup from "@atlaskit/popup";
import { Code } from "@atlaskit/code";
import Textfield from "@atlaskit/textfield";
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import TrashIcon from "@atlaskit/icon/glyph/trash";
import AddIcon from "@atlaskit/icon/glyph/add";
import CheckIcon from '@atlaskit/icon/glyph/check';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';
import { N40 } from "@atlaskit/theme/dist/esm/colors";
import { Permission } from "../../../../__generated__/graphql-global-types";
import buildSystemsQuery from "./build-systems.query.graphql";
import buildSystemsMutation from "./build-systems.mutation.graphql";
var _a = require("@atlaskit/page"), Grid = _a.Grid, GridColumn = _a.GridColumn;
var AkSpinner = require("@atlaskit/spinner").default;
var Select = require("@atlaskit/select").default;
var BuildSystemsDiv = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  width: 100%;\n  padding: 0em 0em 4em 0em;\n"], ["\n  align-items: center;\n  width: 100%;\n  padding: 0em 0em 4em 0em;\n"])));
var LoadingSpinnerWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-left: 1em;\n"], ["\n  margin-left: 1em;\n"])));
var HelpIconDiv = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 1px;\n  margin-left: 5px;\n"], ["\n  margin-top: 1px;\n  margin-left: 5px;\n"])));
var HelpPopupDiv = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 25em;\n  padding: 10px;\n  overflow-wrap: break-word;\n"], ["\n  width: 25em;\n  padding: 10px;\n  overflow-wrap: break-word;\n"])));
var EditIconsSpan = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) { return "\n  padding: 3px;\n  margin: 0px 5px 0px 5px;\n  " + (props.mutating
    ? ""
    : "\n      &:hover {\n        border-radius: 5px;\n        background: " + N40 + ";\n        cursor: pointer;\n      }\n  ") + "\n"; });
var EditModeGridWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-top: -1em;\n"], ["\n  margin-top: -1em;\n"])));
var BuildSystemsTags = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  padding-top: 5px;\n  padding-left: 5px;\n"], ["\n  padding-top: 5px;\n  padding-left: 5px;\n"])));
var NoneDiv = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  font-size: 18px;\n  padding: 0em 0.5em 0em 0.5em;\n"], ["\n  font-size: 18px;\n  padding: 0em 0.5em 0em 0.5em;\n"])));
var TitleDiv = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  font-size: 1em;\n  font-style: inherit;\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: 16px;\n  line-height: 24px;\n  color: rgb(23, 43, 77);\n  overflow-wrap: break-word;\n  min-width: 0px;\n"], ["\n  display: flex;\n  font-size: 1em;\n  font-style: inherit;\n  font-weight: 600;\n  letter-spacing: -0.003em;\n  margin-top: 16px;\n  line-height: 24px;\n  color: rgb(23, 43, 77);\n  overflow-wrap: break-word;\n  min-width: 0px;\n"])));
var IconDiv = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  display: flex;\n  margin-top: 3.3em;\n"], ["\n  display: flex;\n  margin-top: 3.3em;\n"])));
var IconSpan = styled.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) { return "\n  padding: 14px 3px 7px 3px;\n  margin-right: 5px;\n  " + (props.mutating
    ? ""
    : "\n      &:hover {\n        border-radius: 5px;\n        background: " + N40 + ";\n        cursor: pointer;\n      }\n  ") + "\n"; });
var issuerHeader = "X-Slauth-Issuer";
var principalHeader = "X-Slauth-Build-Principal";
export var deploymentSystems = [
    { issuer: "deployment-bamboo", name: "Deployment Bamboo", fieldName: "Deployment Plan Key", help: (React.createElement(HelpPopupDiv, null,
            "You can find this value set in your deployment plan, or by navigating to your plan on",
            " ",
            React.createElement(Link, { to: "https://deployment-bamboo.internal.atlassian.com/browse/" }, "https://deployment-bamboo.internal.atlassian.com/browse/[my_plan_key]"),
            " ",
            "and getting the key from the url."))
    },
    { issuer: "engservices-bamboo", name: "Engineering Bamboo", fieldName: "Deployment Plan Key", help: (React.createElement(HelpPopupDiv, null,
            "You can find this value set in your deployment plan, or by navigating to your plan on",
            " ",
            React.createElement(Link, { to: "https://engservices-bamboo.internal.atlassian.com/browse/" }, "https://engservices-bamboo.internal.atlassian.com/browse/[my_plan_key]"),
            " ",
            "and getting the key from the url."))
    },
    { issuer: "pipelinesBuild", name: "Bitbucket Pipelines", fieldName: "Repository UUID", help: (React.createElement(HelpPopupDiv, null,
            "You can find this value by querying",
            React.createElement("br", null),
            React.createElement(Code, { language: "text", text: "https://bitbucket.org/!api/2.0/repositories/[my_team]/[repo_name]" }),
            React.createElement("p", null),
            "One way of doing this is by using Atlas CLI and running the following curl command:",
            " ",
            React.createElement("br", null),
            React.createElement(Code, { language: "text", text: "curl -H \"Authorization: $(atlas slauth oauth -s team -a bitbucket.org -o http)\" 'https://bitbucket.org/!api/2.0/repositories/[my_team]/[repo_name]' -s | jq -r '.uuid'" })))
    },
    { issuer: "", name: "Other", fieldName: "Principal" }
];
var otherSystem = deploymentSystems.find(function (system) { return system.name === "Other"; });
export var BuildSystems = function (_a) {
    var _b;
    var serviceId = _a.serviceId;
    var _c = useState(false), editMode = _c[0], setEditMode = _c[1];
    var _d = useState(false), showHelpPopup = _d[0], setShowHelpPopup = _d[1];
    var _e = useState([]), curSystems = _e[0], setCurSystems = _e[1];
    var showFlag = useShowFlag();
    var track = useAnalytics();
    var _f = useQuery(buildSystemsQuery, { variables: { id: serviceId } }), loading = _f.loading, error = _f.error, data = _f.data;
    var _g = useMutation(buildSystemsMutation), updateService = _g[0], mutating = _g[1].loading;
    var defaultSystems = function () {
        var _a;
        var attrs = (_a = data === null || data === void 0 ? void 0 : data.service) === null || _a === void 0 ? void 0 : _a.attributes.deployTokensAttribute;
        // No existing attribute in SC
        if (!(attrs === null || attrs === void 0 ? void 0 : attrs.value)) {
            return [{
                    system: deploymentSystems[0],
                    showHelp: false,
                    attr: {
                        name: deploymentSystems[0].name + "-0",
                        headers: [
                            { header: issuerHeader, value: deploymentSystems[0].issuer },
                            { header: principalHeader, value: "" }
                        ]
                    }
                }];
        }
        return attrs.value.map(function (val) {
            var _a, _b;
            var system = {
                showHelp: false,
                system: otherSystem,
                attr: {
                    name: val.name,
                    headers: ((_a = val.headers) !== null && _a !== void 0 ? _a : []).map(function (h) { return ({
                        header: h.header,
                        value: h.value
                    }); })
                }
            };
            if (!system.attr.headers.find(function (h) { return h.header === principalHeader; })) {
                system.attr.headers.push({ header: principalHeader, value: "" });
            }
            // Find the relevant DeploymentSystem for the given issuer header.
            // If the issuer header doesn't exist, make a placeholder that a user can fill in.
            var issuer = system.attr.headers.find(function (header) { return header.header === issuerHeader; });
            if (issuer) {
                system.system = (_b = deploymentSystems.find(function (s) { return s.issuer == issuer.value; })) !== null && _b !== void 0 ? _b : otherSystem;
            }
            else {
                system.attr.headers.push({ header: issuerHeader, value: "" });
            }
            return system;
        });
    };
    var saveBuildSystems = function () { return __awaiter(void 0, void 0, void 0, function () {
        var attrs, errFound_1, newSystems, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!(data === null || data === void 0 ? void 0 : data.service)) {
                        throw new Error("Could not fetch service data");
                    }
                    attrs = data.service.attributes.deployTokensAttribute;
                    errFound_1 = false;
                    curSystems.map(function (system) {
                        var _a;
                        (((_a = system === null || system === void 0 ? void 0 : system.attr) === null || _a === void 0 ? void 0 : _a.headers) || []).map(function (header) {
                            if (system.system !== otherSystem && header.value === "") {
                                system.error = "Value cannot be empty.";
                                errFound_1 = true;
                            }
                        });
                    });
                    if (errFound_1) {
                        track("MicrosDeploymentsPage.BuildSystems: InvalidBuildSystem", {
                            category: "error"
                        });
                        newSystems = curSystems.slice();
                        setCurSystems(newSystems);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, updateService({
                            variables: {
                                input: {
                                    id: serviceId,
                                    attributes: {
                                        deployTokensAttribute: {
                                            value: curSystems.map(function (system) { return system.attr; }),
                                            etag: attrs ? attrs.etag : undefined,
                                        },
                                    },
                                },
                            },
                        })];
                case 1:
                    _a.sent();
                    track("MicrosDeploymentsPage.BuildSystems: SaveSuccess", {
                        category: "info"
                    });
                    showFlag({
                        type: "success",
                        title: "Build Systems Updated",
                        message: "Build Systems have been successfully updated.",
                    });
                    setEditMode(false);
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    track("MicrosDeploymentsPage.BuildSystems: SaveFailed", {
                        category: "error",
                    });
                    showFlag({
                        type: "error",
                        title: "Failed to save Build Systems",
                        message: e_1.toString(),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (error) {
            showFlag({
                type: "error",
                title: "Failed to get Build Systems",
                message: error.toString(),
                disableAutoDismiss: true
            });
            track("MicrosDeploymentsPage.BuildSystems: FetchDataFailed", {
                category: "error"
            });
        }
    }, [error]);
    useEffect(function () {
        if (data) {
            setCurSystems(defaultSystems());
        }
    }, [data]);
    var header = (React.createElement(React.Fragment, null,
        React.createElement("h3", null, "Build Systems Allowed to Deploy:"),
        React.createElement(Popup, { id: "header-help-popup", content: function () { return React.createElement(HelpPopupDiv, null, "This section details what systems (i.e. plans from Bamboo, or repos from Bitbucket Pipelines) have permission to deploy this service."); }, onClose: function () { return setShowHelpPopup(function (help) { return !help; }); }, placement: "right-start", isOpen: showHelpPopup, trigger: function (triggerProps) {
                return React.createElement("div", __assign({}, triggerProps, { ref: triggerProps.ref, onClick: function () { return setShowHelpPopup(function (help) { return !help; }); } }),
                    React.createElement(HelpIconDiv, null,
                        React.createElement(QuestionCircleIcon, { label: "help-icon" })));
            } })));
    if (loading) {
        return (React.createElement(BuildSystemsDiv, null,
            React.createElement(FlexDiv, null,
                header,
                React.createElement(LoadingSpinnerWrapper, null,
                    React.createElement(AkSpinner, { size: "small" })))));
    }
    return (React.createElement(BuildSystemsDiv, null,
        React.createElement(FlexDiv, null,
            header,
            !error && isSufficientPermission(((_b = data === null || data === void 0 ? void 0 : data.service) === null || _b === void 0 ? void 0 : _b.currentUserPermission) || Permission.Read, Permission.Write) &&
                (editMode ? (
                // Edit mode Icons
                React.createElement(React.Fragment, null,
                    React.createElement(EditIconsSpan, { id: "save-icon", mutating: mutating, onClick: saveBuildSystems }, mutating ? (React.createElement(AkSpinner, { size: "small" })) : (React.createElement(Tooltip, { content: "Save" },
                        React.createElement(CheckIcon, { label: "save" })))),
                    React.createElement(EditIconsSpan, { id: "cancel-icon", mutating: mutating, onClick: function () {
                            setEditMode(function (mode) { return !mode; });
                            setCurSystems(defaultSystems());
                        } },
                        React.createElement(Tooltip, { content: "Cancel" },
                            React.createElement(CrossIcon, { primaryColor: mutating ? N40 : undefined, label: "cancel" }))))) : (
                // View Mode Icons
                React.createElement(EditIconsSpan, { id: "edit-icon", mutating: mutating, onClick: function () { return setEditMode(function (mode) { return !mode; }); } },
                    React.createElement(Tooltip, { content: "Edit" },
                        React.createElement(EditFilledIcon, { primaryColor: mutating ? N40 : undefined, label: "edit" })))))),
        editMode ? (
        // Edit Mode rows
        curSystems.map(function (system, index) { return (React.createElement(EditModeGridWrapper, { key: index },
            React.createElement(Grid, null,
                React.createElement(GridColumn, { medium: 4 },
                    React.createElement(TitleDiv, null, "Deployment System:"),
                    React.createElement(Select, { id: "system-select-" + index, isDisabled: mutating, options: deploymentSystems.map(function (system) { return ({ label: system.name, value: system }); }), value: { label: system.system.name, value: system.system }, onChange: function (_a) {
                            var value = _a.value;
                            var newSystems = curSystems.slice();
                            newSystems[index].system = value;
                            newSystems[index].attr.name = value.name + "-" + index;
                            newSystems[index].attr.headers.find(function (h) { return h.header === issuerHeader; }).value = value.issuer;
                            setCurSystems(newSystems);
                        } })),
                system.system === otherSystem && (React.createElement(GridColumn, { medium: 3 },
                    React.createElement(TitleDiv, null, "Issuer:"),
                    React.createElement(Textfield, { id: "issuer-field-" + index, isDisabled: mutating, value: system.attr.headers.find(function (h) { return h.header === issuerHeader; }).value, onChange: function (e) {
                            var newSystems = curSystems.slice();
                            newSystems[index].attr.headers.find(function (h) { return h.header === issuerHeader; }).value = e.target.value;
                            setCurSystems(newSystems);
                        } }))),
                React.createElement(GridColumn, { medium: system.system === otherSystem ? 3 : 6 },
                    React.createElement(TitleDiv, null,
                        system.system.fieldName,
                        ":",
                        system.system.help && (React.createElement(Popup, { id: "help-popup-" + index, content: function () { return system.system.help; }, isOpen: system.showHelp, onClose: function () {
                                var newSystems = curSystems.slice();
                                newSystems[index].showHelp = false;
                                setCurSystems(newSystems);
                            }, placement: "right-start", trigger: function (triggerProps) {
                                return React.createElement("div", __assign({}, triggerProps, { ref: triggerProps.ref, onClick: function () {
                                        var newSystems = curSystems.slice();
                                        newSystems[index].showHelp = !newSystems[index].showHelp;
                                        setCurSystems(newSystems);
                                    } }),
                                    React.createElement(HelpIconDiv, null,
                                        React.createElement(QuestionCircleIcon, { label: "help-icon", size: "small" })));
                            } }))),
                    React.createElement(Tooltip, { content: system.system !== otherSystem && system.error },
                        React.createElement(Textfield, { id: "principal-field-" + index, isDisabled: mutating, value: system.attr.headers.find(function (h) { return h.header === principalHeader; }).value, isInvalid: system.system !== otherSystem && !!system.error, onChange: function (e) {
                                var newSystems = curSystems.slice();
                                newSystems[index].attr.headers.find(function (h) { return h.header === principalHeader; }).value = e.target.value;
                                newSystems[index].error = undefined;
                                setCurSystems(newSystems);
                            } }))),
                React.createElement(GridColumn, { medium: 2 },
                    React.createElement(IconDiv, null,
                        (index != 0 || curSystems.length > 1) && (React.createElement(Tooltip, { content: "Remove Row" },
                            React.createElement(IconSpan, { id: "remove-row-" + index, mutating: mutating, onClick: function () {
                                    var newSystems = curSystems.slice();
                                    newSystems.splice(index, 1);
                                    setCurSystems(newSystems);
                                } },
                                React.createElement(TrashIcon, { primaryColor: mutating ? N40 : undefined, label: "remove" })))),
                        index == curSystems.length - 1 && (React.createElement(Tooltip, { content: "Add Row" },
                            React.createElement(IconSpan, { id: "add-row", mutating: mutating, onClick: function () {
                                    var newSystems = curSystems.slice();
                                    newSystems.push({
                                        system: deploymentSystems[0],
                                        showHelp: false,
                                        attr: {
                                            name: deploymentSystems[0].name + "-" + index,
                                            headers: [
                                                { header: issuerHeader, value: deploymentSystems[0].issuer },
                                                { header: principalHeader, value: "" }
                                            ]
                                        }
                                    });
                                    setCurSystems(newSystems);
                                } },
                                React.createElement(AddIcon, { primaryColor: mutating ? N40 : undefined, label: "add" }))))))))); })) : (
        // View Mode tags
        React.createElement(BuildSystemsTags, null, curSystems.length > 0 && curSystems[0].attr.headers.find(function (h) { return h.header === principalHeader; }).value !== "" ? (React.createElement(Tags, { tags: curSystems.map(function (plan) { return ({
                label: plan.attr.name,
                value: plan.attr.headers.find(function (h) { return h.header === issuerHeader; }).value + ":" + plan.attr.headers.find(function (h) { return h.header === principalHeader; }).value,
                isSelected: true
            }); }) })) : (React.createElement(NoneDiv, null, "None."))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
